module.exports = __webpack_public_path__ + "img/r1.7a5a5a7f.jpeg";